import React from 'react'
import PropTypes from 'prop-types'
import {
    PAYMENT_METHOD_CHRYSALIS_RATE_PAY,
    PAYMENT_METHOD_KLARNA,
    PAYMENT_METHOD_PAYPAL,
    PAYMENT_METHOD_PREPAYMENT,
    PAYMENT_METHOD_SEPA
} from '../../../../constant/sales-order-constant'
import { BACKEND_URL } from '../../../../util/api'
import { PAYMENT_METHOD_TEXT } from '../../state/const'
import { formatMoney } from '../../../../util/money'

const SEPA_XML_DOWNLOAD = BACKEND_URL + '/api/sepa/download-sepa-xml?sepaMandateId='


const StripeSubscription = ({ salesOrder }) => {
    const stripeSubscription = salesOrder.stripeSubscription

    if (!stripeSubscription) {
        return null
    }
    const treatmentQuotation = salesOrder.treatmentQuotation
    const rateDetails = treatmentQuotation ? treatmentQuotation.rateCount + ' x ' + formatMoney(treatmentQuotation.rateMonthly, treatmentQuotation.currency) : ''

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
                </tr>
                <tr>
                    <td>Ratepay</td>
                    <td>{rateDetails}</td>
                </tr>
                <tr>
                    <td>Name on card</td>
                    <td>{stripeSubscription.name}</td>
                </tr>
                <tr>
                    <td>Card</td>
                    <td>{stripeSubscription.brand + ' ****' + stripeSubscription.last4 + ' valid until ' + stripeSubscription.expMonth + '/' + stripeSubscription.expYear}</td>
                </tr>
                <tr>
                    <td>Subscription</td>
                    <td><a href={'https://dashboard.stripe.com/subscriptions/' + stripeSubscription.stripeId} target="_blank" rel="noopener noreferrer">{stripeSubscription.stripeId}<i className="fa fa-external-link" /></a></td>
                </tr>
                <tr>
                    <td>Plan</td>
                    <td><a href={'https://dashboard.stripe.com/plans/' + stripeSubscription.planId} target="_blank" rel="noopener noreferrer">{stripeSubscription.planId}<i className="fa fa-external-link" /></a></td>
                </tr>
            </tbody>
        </table>
    )
}

const StripeTransaction = ({ salesOrder }) => {
    const stripeTransaction = salesOrder.stripeTransaction
    if (!stripeTransaction) {
        return null
    }

    const cardInfo = stripeTransaction.brand + ' ****' + stripeTransaction.last4 + ' valid until ' + stripeTransaction.expMonth + '/' + stripeTransaction.expYear;

    const isCardTransaction = stripeTransaction.paymentMethod === 'credit_card';

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
                </tr>
                <tr>
                    <td>Ratepay</td>
                    <td>no</td>
                </tr>
                {isCardTransaction && (
                    <React.Fragment>
                        <tr>
                            <td>Name on card</td>
                            <td>{stripeTransaction.name}</td>
                        </tr>
                        <tr>
                            <td>Card</td>
                            <td>{cardInfo}</td>
                        </tr>
                    </React.Fragment>
                )}
                <tr>
                    <td>Transaction</td>
                    <td>
                        <a href={'https://dashboard.stripe.com/payments/' + stripeTransaction.transactionId}
                            target="_blank" rel="noopener noreferrer">{stripeTransaction.transactionId}<i className="fa fa-external-link" /></a>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

const PledgPayment = ({ salesOrder, pledgPayment }) => {

    return (
        <table className="sales-order-info-table">
            <tbody>
            <tr>
                <td>Payment Method</td>
                <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
            </tr>
            <tr>
                <td>Terms</td>
                <td>{salesOrder.rateCount} months </td>
            </tr>
            <tr>
                <td>Charge ID</td>
                <td>{pledgPayment.chargeId}</td>
            </tr>
            <tr>
                <td>Reference</td>
                <td>{pledgPayment.reference}</td>
            </tr>
            </tbody>
        </table>
    )
}

const ZabPayment = ({ zabPayment, currency }) => {
    const isRatePay = zabPayment.paymentMethod === 'zab_ratepay'

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[zabPayment.paymentMethod]}</td>
                </tr>
                {
                    isRatePay && (
                        <tr>
                            <td>Terms (Sunshine)</td>
                            <td>{zabPayment.rateCount + ' x '} {formatMoney(zabPayment.rateMonthly, currency)} </td>
                        </tr>
                    )
                }
                {
                    isRatePay && (
                        <tr>
                            <td>Terms (incl. Physician)</td>
                            <td>{zabPayment.rateCount + ' x '} {formatMoney(zabPayment.rateMonthlyTotal, currency)} </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    )
}

const TabeoPayment = ({ tabeoPayment }) => {
    const isRatePay = tabeoPayment.paymentMethod === 'tabeo_ratepay'

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[tabeoPayment.paymentMethod]}</td>
                </tr>
                {
                    isRatePay && (
                        <tr>
                            <td>Terms </td>
                            <td>{tabeoPayment.rateCount} months </td>
                        </tr>
                    )
                }

            </tbody>
        </table>
    )
}

const ChrysalisPayment = ({ salesOrder }) => {
    const isRatePay = salesOrder.paymentMethod === PAYMENT_METHOD_CHRYSALIS_RATE_PAY

    return (
        <table className="sales-order-info-table">
            <tbody>
            <tr>
                <td>Payment Method</td>
                <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
            </tr>
            {
                isRatePay && (
                    <tr>
                        <td>Terms </td>
                        <td>{salesOrder.rateCount} months </td>
                    </tr>
                )
            }

            </tbody>
        </table>
    )
}

const SplititPayment = ({ splititPayment }) => {
    const isRatePay = splititPayment.paymentMethod === 'splitit_ratepay'

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[splititPayment.paymentMethod]}</td>
                </tr>
                {
                    isRatePay && (
                        <tr>
                            <td>Terms </td>
                            <td>{splititPayment.rateCount} months </td>
                        </tr>
                    )
                }

            </tbody>
        </table>
    )
}

const PagaMasTardePayment = ({ pagaMasTardePayment }) => {
    const isRatePay = pagaMasTardePayment.paymentMethod === 'pagamastarde_ratepay'

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[pagaMasTardePayment.paymentMethod]}</td>
                </tr>
                {
                    isRatePay && (
                        <tr>
                            <td>Terms </td>
                            <td>{pagaMasTardePayment.rateCount} months </td>
                        </tr>
                    )
                }

            </tbody>
        </table>
    )
}


const PrePayment = ({ salesOrder }) => {
    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
                </tr>
            </tbody>
        </table>
    )
}

const KlarnaPayment = ({ salesOrder }) => {
    return (
        <table className="sales-order-info-table">
            <tbody>
            <tr>
                <td>Payment Method</td>
                <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
            </tr>
            </tbody>
        </table>
    )
}


const SepaDetails = ({ salesOrder }) => {
    const treatmentQuotation = salesOrder.treatmentQuotation
    const rateDetails = treatmentQuotation ? treatmentQuotation.rateCount + ' x ' + formatMoney(treatmentQuotation.rateMonthly, treatmentQuotation.currency) : ''

    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
                </tr>
                <tr>
                    <td>Ratepay</td>
                    <td>{salesOrder.isRatePay ? rateDetails : 'no'}</td>
                </tr>
                <tr>
                    <td>IBAN</td>
                    <td>{salesOrder.iban}</td>
                </tr>
                <tr>
                    <td>Account Owner</td>
                    <td>{salesOrder.accountOwner}</td>
                </tr>
                {salesOrder.sepaMandate && (
                    <tr>
                        <td>
                            Sepa Mandate
                        </td>
                        <td>
                            <a href={SEPA_XML_DOWNLOAD + salesOrder.sepaMandate.id}>download</a>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

const getPayPalId = ({ paymentExecution }) => {
    if (!paymentExecution) {
        return null
    }

    const { transactions } = paymentExecution
    if (!transactions) {
        return null
    }

    const transaction = transactions[0]
    if (!transaction) {
        return null
    }

    const { related_resources } = transaction
    if (!related_resources) {
        return null
    }

    const related_resource = related_resources[0]
    if (!related_resource) {
        return null
    }

    const { sale } = related_resource
    if (!sale) {
        return null
    }

    return sale.id
}


const PayPalPaymentDetails = ({ salesOrder }) => {
    const { payPalPayment } = salesOrder
    if (!payPalPayment) {
        return null
    }
    const payPalId = getPayPalId(payPalPayment)


    return (
        <table className="sales-order-info-table">
            <tbody>
                <tr>
                    <td>Payment Method</td>
                    <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
                </tr>
                <tr>
                    <td>Transaction</td>
                    <td><a href={'https://www.paypal.com/activity/payment/' + payPalId} target="_blank" rel="noopener noreferrer">{payPalId}<i className="fa fa-external-link" /></a></td>
                </tr>
            </tbody>
        </table>
    )
}

const SalesOrderPaymentDetails = ({ salesOrder }) => {

    if (salesOrder.pledgPayment) {
        return <PledgPayment pledgPayment={salesOrder.pledgPayment} salesOrder={salesOrder}/>
    }

    if (salesOrder.zabPayment) {
        return <ZabPayment zabPayment={salesOrder.zabPayment} currency={salesOrder.currency} />
    }

    if (salesOrder.tabeoPayment) {
        return <TabeoPayment tabeoPayment={salesOrder.tabeoPayment} />
    }

    if (salesOrder.paymentMethod === PAYMENT_METHOD_CHRYSALIS_RATE_PAY) {
        return <ChrysalisPayment salesOrder={salesOrder} />
    }

    if (salesOrder.splititPayment) {
        return <SplititPayment splititPayment={salesOrder.splititPayment} />
    }

    if (salesOrder.pagaMasTardePayment) {
        return <PagaMasTardePayment pagaMasTardePayment={salesOrder.pagaMasTardePayment} />
    }

    if (salesOrder.paymentMethod === PAYMENT_METHOD_PREPAYMENT) {
        return <PrePayment salesOrder={salesOrder} />
    }

    if (salesOrder.paymentMethod === PAYMENT_METHOD_KLARNA) {
        return <KlarnaPayment salesOrder={salesOrder} />
    }

    if (salesOrder.paymentMethod === PAYMENT_METHOD_SEPA) {
        return <SepaDetails salesOrder={salesOrder} />
    }

    if (salesOrder.paymentMethod === PAYMENT_METHOD_PAYPAL) {
        return <PayPalPaymentDetails salesOrder={salesOrder} />
    }

    if (salesOrder.stripeTransaction || salesOrder.stripeSubscription) {
        return (
            <div>
                <StripeTransaction salesOrder={salesOrder} />
                <StripeSubscription salesOrder={salesOrder} />
            </div>)
    }

    return null
}

SalesOrderPaymentDetails.propTypes = {
    salesOrder: PropTypes.object.isRequired,
}

export default SalesOrderPaymentDetails



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderPaymentDetails.js